import { SelectProps } from 'antd';
import { BaseSelectRef } from 'rc-select/lib/BaseSelect';
import { forwardRef, useCallback } from 'react';

import { useMarketsInSelectFieldLazyQuery } from '../../graphql/markets.generated';
import AsyncSelect from '../Input/AsyncSelect';

export type SelectFieldProps = SelectProps & {
  initialOption?: { value: number; label: string };
  initialLoad?: boolean;
};

const MarketSelect = forwardRef<BaseSelectRef, SelectFieldProps>(function (
  { initialLoad, ...props },
  ref
) {
  const [fetchMarket] = useMarketsInSelectFieldLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const fetchItems = useCallback(
    async (name: string) => {
      const { data } = await fetchMarket({
        variables: {
          filter: { name },
          pagination: { skip: 0, take: 20 },
        },
      });
      return (
        data?.adminMarkets.edges.map(({ node }) => ({
          label: node.name,
          value: node.id,
          data: node,
        })) || []
      );
    },
    [fetchMarket]
  );

  return (
    <AsyncSelect
      ref={ref}
      initialLoad={initialLoad}
      className={'w-full'}
      fetchItems={fetchItems}
      {...props}
    />
  );
});

export default MarketSelect;
